import "./assets/css/main.css";
// Direct import used due to an issue in the types, see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/43848#issuecomment-1120406623
import ReactDOM from "react-dom/client";
import App from "./App";
import { Amplify } from "aws-amplify";
import "./i18n";
import React from "react";

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_POOL_ID as string,
      userPoolClientId: process.env.REACT_APP_COGNITO_POOL_CLIENT_ID as string,
      username: "true",
      email: "true",
    },
  },
};

Amplify.configure(amplifyConfig);
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
